import { render, staticRenderFns } from "./TrainRecord.vue?vue&type=template&id=4d8f40dc&scoped=true&"
import script from "./TrainRecord.vue?vue&type=script&lang=js&"
export * from "./TrainRecord.vue?vue&type=script&lang=js&"
import style0 from "./TrainRecord.vue?vue&type=style&index=0&id=4d8f40dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f40dc",
  null
  
)

export default component.exports